<template>
  <div v-if="isVisible" class="ra-geo-modal" :data-refapp-tagging-id="taggingId">
    <refapp-geoip-option
      :image="image"
      :title="title"
      :description="description"
      :countries="countries"
      :cookie-expiration="cookieExpiration"
      :redirect-label="redirectLabel"
      :continue-label="continueLabel"
      :default-country-code="defaultCountryCode"
      :btn-bg-color="btnBgColor"
      :btn-text-color="btnTextColor"
      @close-modal="handleCloseModal"
    ></refapp-geoip-option>
  </div>
</template>

<script>
import RefappGeoipOption from './base/refapp-geoip.vue';
import tagging from '../lib/tagging/mixin';
import { geoipProps } from './base/props-definitions';

export default {
  name: 'refapp-geoip-redirect',
  components: {
    RefappGeoipOption,
  },
  mixins: [tagging],
  props: {
    taggingId: {
      type: String,
      required: true,
    },
    ...geoipProps,
  },
  data() {
    return {
      isVisible: this.$cookies.get('geoip-redirect') === null,
    };
  },
  methods: {
    handleCloseModal() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss" src="../styles/entry.scss"></style>
